import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OnboardingRoutingModule } from './onboarding-routing.module';
import { LandingComponent } from './pages/landing/landing.component';
import { BecomePartnerComponent } from './pages/become-partner/become-partner.component';
import { GuestFooterComponent } from './components/guest-home/guest-footer/guest-footer.component';
import { ProgramFeaturesComponent } from './components/guest-home/program-features/program-features.component';
import { ChooseProgramComponent } from './components/guest-home/choose-program/choose-program.component';
import { ProgramBenefitsComponent } from './components/guest-home/program-benefits/program-benefits.component';
import { GuestCarouselComponent } from './components/guest-home/guest-carousel/guest-carousel.component';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { PartnerHeaderComponent } from './components/new-partner/partner-header/partner-header.component';
import { PartnerAccountDetailsComponent } from './components/new-partner/partner-account-details/partner-account-details.component';
import { PartnerBusinessDetailsComponent } from './components/new-partner/partner-business-details/partner-business-details.component';
import { OwnerDetailsComponent } from './components/new-partner/owner-details/owner-details.component';
import { PartnerLegalInfoComponent } from './components/new-partner/partner-legal-info/partner-legal-info.component';
import { LibraryModule } from '../../library/library.module';
import { MarkdownModule } from 'ngx-markdown';
import { RegistrationSuccessComponent } from '../../shared/components/registration-success/registration-success.component';
import { GuestHeaderComponent } from './components/guest-home/guest-header/guest-header.component';
import { FormsModule } from '@angular/forms';



@NgModule({
  declarations: [
    LandingComponent,
    BecomePartnerComponent,
    GuestHeaderComponent,
    GuestFooterComponent,
    ProgramFeaturesComponent,
    ChooseProgramComponent,
    ProgramBenefitsComponent,
    GuestCarouselComponent,
    PartnerHeaderComponent,
    PartnerAccountDetailsComponent,
    PartnerBusinessDetailsComponent,
    OwnerDetailsComponent,
    PartnerLegalInfoComponent
  ],
  imports: [
    CommonModule,
    OnboardingRoutingModule,
    LibraryModule,
    CarouselModule,
    FormsModule,
    MarkdownModule.forRoot(),
  ]
})
export class OnboardingModule { }
